import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { PollStatusBadge } from './PollStatusBadge';

interface PollCardProps {
  pollId: string;
  title: string;
  status: string;
  closesAt: string | null;
  createdAt: string;
}

export function PollCard({ pollId, title, status, closesAt, createdAt }: PollCardProps) {
  const navigate = useNavigate();

  return (
    <Card
      className="cursor-pointer hover:bg-accent/50 transition-colors"
      onClick={() => navigate(`/a/arche_polls/${pollId}`)}
    >
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base font-medium truncate">{title}</CardTitle>
          <PollStatusBadge status={status} />
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex items-center gap-4 text-sm text-muted-foreground">
          <span>Created {new Date(createdAt).toLocaleDateString()}</span>
          {closesAt && (
            <span>
              {new Date(closesAt) > new Date() ? 'Closes' : 'Closed'}{' '}
              {new Date(closesAt).toLocaleDateString()}
            </span>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
